module.exports = __webpack_public_path__ + "static/media/img20.c4ed8bea.JPG";